import { render, staticRenderFns } from "./trainingAgenda.vue?vue&type=template&id=c077e086&scoped=true&"
import script from "./trainingAgenda.vue?vue&type=script&lang=js&"
export * from "./trainingAgenda.vue?vue&type=script&lang=js&"
import style0 from "./trainingAgenda.vue?vue&type=style&index=0&id=c077e086&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c077e086",
  null
  
)

export default component.exports